module.exports = __webpack_public_path__ + "img/calendar-grey.d536ada0.svg";